module.exports = __webpack_public_path__ + "static/media/bg-scribble.088757e5.svg";